<div pias-layout-content>
  @if(this.setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <br>

  <div class="page-container" [formGroup]="assessmentForm">
    <h5 class="page-header">New Representative’s Appointment Checklist</h5>
    <h5 class="field-title">Application Details</h5>
    <div class="row">
      <!-- Name of Applicant -->
      <div class="col-md-6">
        <label class="field-label">
          Name of Applicant
        </label>

        <mat-form-field class="w-100">
          <input matInput formControlName="name" placeholder="Enter Name" readonly />
        </mat-form-field>
      </div>

      <!-- Recruiting Manager -->
      <div class="col-md-6">
        <label class="field-label">
          Recruiting Manager
        </label>

        <mat-form-field class="w-100">
          <input matInput formControlName="manager" placeholder="Enter Recruiting Manager" readonly />
        </mat-form-field>
      </div>
      <!-- Branch -->
      <div class="col-md-6">
        <label class="field-label">
          Branch
        </label>

        <mat-form-field class="w-100">
          <input matInput formControlName="branch" placeholder="Enter Branch" readonly />
        </mat-form-field>
      </div>
    </div>

    <!-- Split-screen: checklist (left) + sticky document preview (right) -->
    <div class="content" [class.with-preview]="showPreview">

      <!-- Checklist Table -->
      <div class="table-container" formArrayName="checklist">

        @for (section of checklistData; track section.section) {

        <div class="section-block">

          <!-- SECTION TITLE -->
          <div class="section-title">
            {{ section.section }}
            <p class="section-note">
              {{ section.note1 }}
            </p>
            <p class="section-note">
              {{ section.note2 }}
            </p>
            <p class="section-note">
              {{ section.note3 }}
            </p>
          </div>

          <!-- TABLE -->
          <table id="checklist-table" class="custom-table">

            <thead>
              <tr>
                <th width="50">S/N</th>
                <th>Checklist Items</th>
                @if(this.currentUserRole == 'Onboarding'){
                <th width="120">Onboarding</th>
                } @else if(this.currentUserRole == 'BDM'){
                <th width="80">DM</th>
                } @else if(this.currentUserRole == 'DSU'){
                <th width="80">DSU</th>
                }@else if(this.currentUserRole == 'DSU Manager'){
                <th width="80">DSU Manager</th>
                }
                @else {
                <th width="80">RM</th>
                }
                <th width="120">Action</th>
              </tr>
            </thead>

            <tbody>

              @for (item of section.items; track item.id; let j = $index) {

              @let isPreviewing = showPreview && activePreviewIndex === item.index;

              <tr [formGroupName]="item.index" [class.is-previewing]="isPreviewing">

                <td class="sn-cell">{{ item.id }}</td>

                <td>{{ item.title }}
                  @let rmCheckControl = checklistForm.at(item.index).get('rmCheck');

                  @if (rmCheckControl?.invalid && (rmCheckControl?.touched || rmCheckControl?.dirty)) {
                  <mat-error>
                    @if (rmCheckControl?.errors?.['required']) {
                    <span class="text-center">{{ message }}</span>
                    }@else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </td>

                <td>
                  <mat-checkbox formControlName="rmCheck"
                    (change)="onCheckboxChange($event.checked,item.index)"></mat-checkbox>
                </td>

                <td>
                  @if(item.files?.length == 0){
                  <button mat-stroked-button class="view-btn" [disabled]="true">
                    N/A
                  </button>
                  }@else{
                  <button mat-stroked-button class="view-btn" [class.active]="isPreviewing"
                    [attr.aria-pressed]="isPreviewing" (click)="previewDoc(item)"
                    [matTooltip]="isPreviewing ? 'Currently in the preview panel' : 'Preview alongside the checklist'">
                    <span>View</span>
                  </button>
                  }
                </td>

              </tr>
              }

            </tbody>

          </table>

        </div>

        }
        @if(isReadOnly() == false){
        <div class="form-actions mt-4">
          <button class="save-btn" (click)="saveAndContinue()">
            <span>Save & Continue</span>
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
        }
      </div>

      <!-- Sticky preview panel — never overlays the checklist controls -->
      @if (showPreview) {

      <aside #previewPanel class="preview-panel" [class.is-fullscreen]="isFullscreen" role="region"
        aria-label="Document preview">

        <!-- Header: linked item + quick controls -->
        <div class="preview-header">
          <div class="preview-title">
            <mat-icon class="preview-title-icon">description</mat-icon>
            <div class="preview-title-text">
              <span class="preview-title-main">Document Preview</span>
              @if (activePreviewTitle) {
              <span class="preview-linked-item">
                <span class="linked-sn">S/N {{ activePreviewSn }}</span>
                <span class="linked-title" [matTooltip]="activePreviewTitle">{{ activePreviewTitle }}</span>
              </span>
              }
            </div>
          </div>

          <div class="preview-header-actions">
            @if (!isPdf) {
            <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" matTooltip="Zoom out">
              <mat-icon>zoom_out</mat-icon>
            </button>
            <button type="button" class="zoom-level" (click)="resetZoom()" matTooltip="Reset to fit">
              {{ zoomPercent }}%
            </button>
            <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" matTooltip="Zoom in">
              <mat-icon>zoom_in</mat-icon>
            </button>
            <span class="action-divider"></span>
            }
            <button mat-icon-button (click)="toggleFullscreen()"
              [matTooltip]="isFullscreen ? 'Exit full screen' : 'Full screen'">
              <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
            </button>
            <button mat-icon-button (click)="closePreview()" matTooltip="Close preview (Esc)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <!-- File Tabs (if multiple files) -->
        @if (selectedItemFiles.length > 1) {
        <div class="file-tabs" role="tablist">
          @for (file of selectedItemFiles; track $index; let i = $index) {
          <button class="file-tab" role="tab" [class.active]="selectedFileIndex === i"
            [attr.aria-selected]="selectedFileIndex === i" (click)="loadFile(i)" [matTooltip]="file.name">
            {{ file.name }}
          </button>
          }
        </div>
        }

        <!-- Scrollable / pannable preview surface -->
        <div #scroller class="preview-content" [class.zoomed]="zoomLevel !== 1"
          [class.pannable]="!isPdf && zoomLevel > 1" [class.panning]="isPanning"
          (pointerdown)="onPanStart($event, scroller)" (pointermove)="onPanMove($event, scroller)"
          (pointerup)="onPanEnd($event, scroller)" (pointercancel)="onPanEnd($event, scroller)"
          (wheel)="onWheelZoom($event)">

          @if (previewLoading) {
          <div class="preview-state" aria-live="polite">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p>Loading document…</p>
          </div>
          } @else if (previewError) {
          <div class="preview-state error" aria-live="polite">
            <mat-icon>error_outline</mat-icon>
            <p>{{ previewError }}</p>
            <button mat-stroked-button (click)="loadFile(selectedFileIndex)">Retry</button>
          </div>
          } @else if (isPdf) {
          <iframe [src]="selectedDocument" class="preview-pdf" title="Document preview"></iframe>
          } @else {
          <div class="image-stage" [style.width.%]="zoomLevel === 1 ? null : zoomLevel * 100">
            <img [src]="selectedDocument" alt="Document preview" class="preview-image"
              [class.fit]="zoomLevel === 1" />
          </div>
          }
        </div>

        @if (!isPdf && !previewLoading && !previewError) {
        <div class="preview-footer">
          <mat-icon>info_outline</mat-icon>
          <span>Scroll or drag to pan · Ctrl + scroll to zoom</span>
        </div>
        }

      </aside>

      }
    </div>
  </div>
</div>
